'use client';
import { Box, Container, Flex, Text } from '@chakra-ui/react';
import Link from 'next/link';
import { Logo } from '../ui/svgs/logo';
import { useParams, usePathname } from 'next/navigation';
import { useRouter } from 'next/navigation';
import CommonContainer from '../common/CommonContainer';
import { HEADER_HEIGHT_PC } from '@/lib/config/page';

export function NavPC() {
  const pathname = usePathname();
  const params = useParams();
  const locale = (params?.locale as string) || 'zh-CN';
  const isTraderPage = pathname.split('/').includes('trader')
  
  const navItemStyle = (paths: string[]) => {
    const isActive = paths.some((path) => pathname.includes(path));
    return {
      color: isActive ? 'text.t1' : 'text.t2',
      fontWeight: isActive ? 600 : 400,
      _hover: {
        color: 'text.t1',
      }
    };
  };
  return (
    <Box w="full" px='24px'>
      <Flex h={`${HEADER_HEIGHT_PC}px`} align="center" justify="space-between">
        <Flex align="center" gap={'40px'}>
          <Box cursor={'pointer'}>
            <Logo logoJumpUrl='/home' />
          </Box>
          {isTraderPage ? (
            <></>
          ) : (
            <Flex gap={'24px'} align="center">
              <Link
                href={`/${locale}/app`}
              >
                <Text
                  fontSize={'16px'}
                  {...navItemStyle(['/app'])}
                  whiteSpace={'nowrap'}
                >
                  App
                </Text>
              </Link>
              <Link
                href={`/${locale}/marketplace`}
              >
                <Text
                  fontSize={'16px'}
                  {...navItemStyle(['/marketplace'])}
                  whiteSpace={'nowrap'}
                >
                  X402 Market Place
                </Text>
              </Link>
              <Link
                href={`/${locale}/document`}
              >
                <Text
                  fontSize={'16px'}
                  {...navItemStyle(['/document'])}
                  whiteSpace={'nowrap'}
                >
                  Documentation
                </Text>
              </Link>
            </Flex>
          )}
        </Flex>
      </Flex>
    </Box>
  );
}
